import { Controller } from 'stimulus';
import SwiperCore, { Navigation, Autoplay } from 'swiper/core';

class SliderController extends Controller {
  connect() {
    SwiperCore.use([Navigation, Autoplay]);

    this.swiper = new SwiperCore(this.element, {
      ...this.sliderOptionsFromElement(),

      navigation: {
        prevEl: this.hasPrevTarget ? this.prevTarget : null,
        nextEl: this.hasNextTarget ? this.nextTarget : null,
      },
    });
  }

  sliderOptionsFromElement() {
    const options = this.element.dataset;
    const config = {};

    if (typeof options === 'undefined') {
      return config;
    }

    Object.keys(options).forEach((option) => {
      const regex = new RegExp('^slider', 'g');

      if (!regex.test(option)) {
        return;
      }

      // Transform the key from 'sliderArrows' to 'Arrows'
      let value = options[option];
      let transformedOption = option.replace('slider', '');

      // Lowercase the first character ('Arrows' => 'arrows')
      transformedOption = transformedOption[0].toLowerCase() + transformedOption.slice(1);

      if (value === 'true') {
        value = true;
      } else if (value === 'false') {
        value = false;
      }

      config[transformedOption] = transformedOption === 'breakpoints'
        ? JSON.parse(value)
        : value;
    });

    return config;
  }
}

SliderController.targets = [
  //
];

export default SliderController;
